<template>
  <div class="row card">
    <!-- Header -->
    <div class="align-items-center">
      <div class="border-0 mb-4">
        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
          <h3 class="fw-bold mb-0">Bulk SMS</h3>
          
          <!-- Add Appointment button -->
          <div class="col-auto d-flex w-sm-100">
            <button type="button" @click.prevent="toAddMessageTemplate" class="btn btn-primary btn-set-task w-sm-100" data-bs-toggle="modal" data-bs-target="#depadd"><i class="icofont-plus-circle me-2 fs-6"></i>SMS göndər</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row overflow-auto">
      <div class="col-sm-12">
        <table id="patient-table" class="table table-striped table-bordered align-middle mb-0 nowrap dataTable no-footer dtr-inline" style="width: 100%;" role="grid" aria-describedby="patient-table_info">
          <thead>
            <tr role="row">
              <th class="text-center" v-if="user.role == 'Admin'">
                Partner
              </th>
              <th class="text-center">
                Sender
              </th>
              <th class="text-center">
                SMS mətn 
              </th>
              <th class="text-center">
                Redaktə
              </th>
            </tr>
          </thead>
          <tbody>                                    
            <tr v-for="template in templates" :key="template.id" class="text-center">
              <td v-if="user.role == 'Admin'">{{ template.partner }}</td>
              <td>{{ template.shortNumber }}</td>
              <td>{{ template.smsText }}</td>
              <!-- Update -->
              <td>
                <button type="button" class="btn btn-outline-secondary" @click="toUpdateTemplate(template)"><i class="icofont-edit text-success"></i></button>
                <button type="button" class="btn btn-outline-secondary" @click="toDeleteTemplate(template)"><i class="icofont-ui-delete text-danger"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br>
    <pagination
      :totalPages="leng"
      :perPage="request.pageSize"
      :currentPage="request.currentPage"
      @pagechanged="onPageChange"
    />
    <modal name="delete" :widht="800" height="auto" styles="background-color: transparent;">
      <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title  fw-bold" id="expeditLabel">Silmək istədiyinizə əminsiz?</h5>
                    <button type="button" class="btn-close" @click="$modal.hide('delete')" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" @click="remove" data-bs-dismiss="modal">Bəli</button>
                    <button type="button" class="btn btn-danger" @click="$modal.hide('delete')">Xeyr</button>
                </div>
            </div>
            </div>
    </modal>
  </div>
</template>

<script>
import jwtInterceptor from '../../jwt.interceptor'
import store from '../../store'
import user from '../../store/user'
import Pagination from '../parts/site/Pagination.vue'

export default {
  name: 'MessageTemplates',
  components: {
    Pagination
  },
  data() {
    return {
      templates: [],
      user : {},
      rmelm: '',
      request: {
        pageNumber:1,
        pageSize:10,
      },
      totalCount:0,
      leng: 0,
    }
  },
  methods: {
    toAddMessageTemplate() {
      this.$router.push('/bulksms/add')
    },
    toUpdateTemplate(template) {
      user.dispatch('prepareUpdateTemplate', template)
      this.$router.push('/bulksms/update')
    },
    toDeleteTemplate(template){
      this.rmelm = template.id
      this.$modal.show('delete')
    },
    onPageChange(page) {
      this.request.pageNumber = page;
      this.getTemplates();
    },
    remove(){
      jwtInterceptor.delete(this.$store.getters.getUrl+'/BulkSms/'+this.rmelm).
      then((response) => {
        this.getTemplates()
        this.$toast.success('Silindi', {
          position: "top-left"
        })
        this.$modal.hide('delete')
      })
      .catch(error => {
        console.log(error)
        this.$toast.error('Xəta baş verdi!', {
          position: "top-right"
        })
      })
    },
    getTemplates() {
      var url = '/BulkSms';
      if(this.user.role === 'Partner'){
        url+= "/GetAllByUserIdAsync/" + this.user.id;
        this.request.userId = this.user.id;
      }
      jwtInterceptor.get(this.$store.getters.getUrl+url, { params: this.request}).
      then(response => {
        this.templates = response.data.result.items;
        this.totalCount = response.data.result.totalCount;
        this.leng = response.data.result.totalPages;
      })
      .catch(error => {
        console.log(error)
        this.$toast.error('Xəta baş verdi!', {
          position: "top-right"
        })
      })
    },
  },
  created() {
    this.user = user.getters.getUser
    this.getTemplates()
  }
}
</script>

<style>
[data-theme="high-contrast"] {
  .table-striped>tbody>tr:nth-of-type(odd)>* {
    color: white !important;
  }
}
</style>